"use strict";

var _typeof = require("@babel/runtime-corejs2/helpers/typeof");

var _WeakMap = require("@babel/runtime-corejs2/core-js/weak-map");

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

var _Object$getOwnPropertyDescriptor = require("@babel/runtime-corejs2/core-js/object/get-own-property-descriptor");

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = Panel;

var _extends2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/extends"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/slicedToArray"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _helpers = require("@paprika/stylers/lib/helpers");

var _helpers2 = require("@paprika/helpers");

var _overlay = _interopRequireDefault(require("@paprika/overlay"));

var _Content = _interopRequireDefault(require("./components/Content"));

var _Dialog = _interopRequireDefault(require("./components/Dialog"));

var _Footer = _interopRequireDefault(require("./components/Footer"));

var _Header = _interopRequireDefault(require("./components/Header"));

var _Overlay = _interopRequireDefault(require("./components/Overlay"));

var _Trigger = _interopRequireDefault(require("./components/Trigger"));

var _Group = _interopRequireDefault(require("./components/Group"));

var _FocusLock = _interopRequireDefault(require("./components/FocusLock"));

var _PanelContext = _interopRequireDefault(require("./PanelContext"));

var types = _interopRequireWildcard(require("./types"));

var _helpers3 = require("./helpers");

var _hooks = require("./hooks");

var _excluded = ["a11yText", "container", "getPushContentElement", "groupOffsetY", "height", "size", "isInline", "isOpen", "offset", "onAfterClose", "onAfterOpen", "onClose", "slideFrom", "width", "zIndex", "hasAccent"],
    _excluded2 = ["children", "focusLockOptions"];

function _getRequireWildcardCache(nodeInterop) { if (typeof _WeakMap !== "function") return null; var cacheBabelInterop = new _WeakMap(); var cacheNodeInterop = new _WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = _Object$defineProperty && _Object$getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? _Object$getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { _Object$defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var PUSH_REF_TRANSITION_DELAY_STYLE = "0.1s";

function Panel(props) {
  // Props
  var a11yText = props.a11yText,
      container = props.container,
      getPushContentElement = props.getPushContentElement,
      groupOffsetY = props.groupOffsetY,
      height = props.height,
      size = props.size,
      isInline = props.isInline,
      isOpen = props.isOpen,
      offset = props.offset,
      onAfterClose = props.onAfterClose,
      onAfterOpen = props.onAfterOpen,
      onClose = props.onClose,
      slideFrom = props.slideFrom,
      width = props.width,
      zIndex = props.zIndex,
      hasAccent = props.hasAccent,
      moreProps = (0, _objectWithoutProperties2["default"])(props, _excluded);
  var offsetTop = "top" in offset ? offset.top : 0; // Hooks

  var _React$useState = _react["default"].useState(isOpen),
      _React$useState2 = (0, _slicedToArray2["default"])(_React$useState, 2),
      isVisible = _React$useState2[0],
      setIsVisible = _React$useState2[1];

  var offsetScroll = (0, _hooks.useOffsetScroll)(offsetTop);
  var calculatedOffset = {
    top: offsetScroll,
    left: "left" in offset ? offset.left : 0,
    right: "right" in offset ? offset.right : 0
  }; // Refs

  var refTrigger = _react["default"].useRef(null);

  var refPanelContent = _react["default"].useRef(null);

  var refHeader = _react["default"].useRef(null); // Extracts


  var _extractChildren = (0, _helpers3.extractChildren)(props.children, ["Panel.FocusLock", "Panel.Footer", "Panel.Header", "Panel.Overlay", "Panel.Trigger"]),
      focusLockExtracted = _extractChildren["Panel.FocusLock"],
      footerExtracted = _extractChildren["Panel.Footer"],
      headerExtracted = _extractChildren["Panel.Header"],
      overlayExtracted = _extractChildren["Panel.Overlay"],
      triggerExtracted = _extractChildren["Panel.Trigger"],
      children = _extractChildren.children;

  var handleAnimationEnd = function handleAnimationEnd() {
    if (!isOpen) {
      setIsVisible(false);
      onAfterClose();

      if (triggerExtracted) {
        refTrigger.current.focus();
      }

      return;
    }

    onAfterOpen();
  };

  _react["default"].useEffect(function () {
    if (isOpen) {
      setIsVisible(true);
    }
  }, [isOpen]);

  _react["default"].useEffect(function () {
    (0, _helpers3.warnOfPropErrors)(props);
  }, []);

  _react["default"].useLayoutEffect(function () {
    if (getPushContentElement === null) return;
    var pushContentRefStyle = getPushContentElement().style;
    var PUSH_REF_TRANSITION_STYLE = "";
    pushContentRefStyle.transitionDelay = PUSH_REF_TRANSITION_DELAY_STYLE;

    switch (slideFrom) {
      case types.slideFroms.LEFT:
        pushContentRefStyle.marginLeft = isOpen ? width : 0;
        PUSH_REF_TRANSITION_STYLE = isOpen ? "margin-left 0.2s ease" : 0;
        break;

      case types.slideFroms.BOTTOM:
        break;

      default:
        pushContentRefStyle.marginRight = isOpen ? width : 0;
        PUSH_REF_TRANSITION_STYLE = isOpen ? "margin-right 0.2s ease" : 0;
        break;
    }

    return function () {
      pushContentRefStyle.transition = PUSH_REF_TRANSITION_STYLE;
      pushContentRefStyle.transitionDelay = PUSH_REF_TRANSITION_DELAY_STYLE;
    };
  }, [isOpen, slideFrom, getPushContentElement, width]);

  var focusLockProps = focusLockExtracted ? focusLockExtracted.props : {};

  function handleEscKey(event) {
    if (event.key === "Escape") {
      event.stopPropagation();
      onClose();
    }
  }

  var ariaLabel = a11yText || (headerExtracted ? headerExtracted.props.children : null);
  var sidePanel = null;
  var contextValue = {
    size: size
  };

  if (isVisible) {
    var dialog = /*#__PURE__*/_react["default"].createElement(_Dialog["default"], (0, _extends2["default"])({
      a11yText: ariaLabel,
      "data-pka-anchor": "panel",
      footer: footerExtracted,
      getPushContentElement: getPushContentElement,
      groupOffsetY: groupOffsetY,
      header: headerExtracted,
      height: height,
      size: size,
      isInline: isInline,
      isOpen: isOpen,
      offset: calculatedOffset,
      onAnimationEnd: handleAnimationEnd,
      onClose: onClose,
      onKeyDown: handleEscKey,
      refHeader: refHeader,
      refPanelContent: refPanelContent,
      slideFrom: slideFrom,
      width: width,
      zIndex: zIndex,
      hasAccent: hasAccent
    }, moreProps), children);

    if (isInline) {
      sidePanel = dialog;
    } else if (!overlayExtracted) {
      sidePanel = /*#__PURE__*/_react["default"].createElement(_helpers2.Portal, {
        active: true,
        container: container
      }, dialog);
    } else {
      var _overlayExtracted$pro = overlayExtracted.props,
          _children = _overlayExtracted$pro.children,
          focusLockOptions = _overlayExtracted$pro.focusLockOptions,
          morePropsForOverlay = (0, _objectWithoutProperties2["default"])(_overlayExtracted$pro, _excluded2);
      sidePanel = /*#__PURE__*/_react["default"].createElement(_helpers2.Portal, {
        active: true,
        container: container
      }, /*#__PURE__*/_react["default"].createElement(_overlay["default"], (0, _extends2["default"])({
        "data-pka-anchor": "panel.overlay",
        focusLockOptions: focusLockProps,
        hasBackdrop: true,
        isOpen: isOpen,
        onClose: onClose,
        zIndex: zIndex,
        container: container
      }, morePropsForOverlay), function (state) {
        return /*#__PURE__*/_react["default"].cloneElement(dialog, {
          state: state
        });
      }));
    }
  }

  var trigger = triggerExtracted ? /*#__PURE__*/_react["default"].cloneElement(triggerExtracted, {
    ref: refTrigger
  }) : null;
  var shouldDisableBodyOverflow = (overlayExtracted || isInline) && isOpen;
  return /*#__PURE__*/_react["default"].createElement(_PanelContext["default"].Provider, {
    value: contextValue
  }, shouldDisableBodyOverflow && /*#__PURE__*/_react["default"].createElement(_helpers2.LockBodyScroll, null), trigger, sidePanel);
}

Panel.types = {
  slideFrom: types.slideFroms,
  widthType: types.widthTypes,
  size: types.sizes
};
var propTypes = {
  /* Description of the Panel dialog for assistive technology */
  a11yText: _propTypes["default"].string,

  /** The content for the Panel. */
  children: _propTypes["default"].node.isRequired,

  /** Portal container for the Panel (DOM element) */
  container: _helpers2.DOMElementType,

  /** Function that provides the container DOM element to be pushed. */
  getPushContentElement: _propTypes["default"].func,

  /** Y offset that is passed down from <Panel.Group> */
  groupOffsetY: _propTypes["default"].number,

  /** The height of the open Panel (when slide in from bottom) */
  height: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number]),

  /** Control the size of the Panel */
  size: _propTypes["default"].oneOfType([types.sizes.MEDIUM, types.sizes.LARGE]),

  /** Render the panel inline */
  isInline: _propTypes["default"].bool,

  /** Control the visibility of the Panel. This prop makes the Panel appear. */
  isOpen: _propTypes["default"].bool,

  /** Control offset of the Panel. Only use 'top' when sliding in from the left or right. Only use 'left' or 'right' when sliding in from the bottom. */
  offset: _propTypes["default"].shape({
    top: _propTypes["default"].number,
    left: _propTypes["default"].number,
    right: _propTypes["default"].number
  }),

  /** Callback once the Panel has been closed event */
  onAfterClose: _propTypes["default"].func,

  /** Callback once the Panel has been opened event */
  onAfterOpen: _propTypes["default"].func,

  /** Callback triggered when the Panel needs to be close */
  onClose: _propTypes["default"].func,

  /** Control where the Panel slides in from */
  slideFrom: _propTypes["default"].oneOf([types.slideFroms.RIGHT, types.slideFroms.LEFT, types.slideFroms.BOTTOM]),

  /** The width of the open Panel (when slide in from left or right) */
  width: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number, types.widthTypes.SMALL, types.widthTypes.MEDIUM, types.widthTypes.LARGE]),

  /** Control the z-index of the Panel */
  zIndex: _propTypes["default"].number,

  /** Differentiate between similar coloured UI elements */
  hasAccent: _propTypes["default"].bool
};
var defaultProps = {
  a11yText: null,
  container: null,
  getPushContentElement: null,
  groupOffsetY: 0,
  height: "33%",
  size: types.sizes.MEDIUM,
  isInline: false,
  isOpen: false,
  offset: {
    top: 0,
    left: 0,
    right: 0
  },
  onAfterClose: function onAfterClose() {},
  onAfterOpen: function onAfterOpen() {},
  onClose: null,
  slideFrom: types.slideFroms.RIGHT,
  width: "33%",
  zIndex: (0, _helpers.zValue)(7),
  hasAccent: false
};
Panel.propTypes = propTypes;
Panel.defaultProps = defaultProps;
Panel.displayName = "Panel";
Panel.Content = _Content["default"];
Panel.FocusLock = _FocusLock["default"];
Panel.Footer = _Footer["default"];
Panel.Group = _Group["default"];
Panel.Header = _Header["default"];
Panel.Overlay = _Overlay["default"];
Panel.Trigger = _Trigger["default"];
//# sourceMappingURL=Panel.js.map